import { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Grid,
  TextField,
  Divider,
  CardContent,
  FormHelperText,
} from '@material-ui/core';
import RegionSelector from './RegionSelector';

const selectNotificationTo = [
  { value: 'allWashers', label: 'All Washers' },
  { value: 'activeWashers', label: 'Online Washers' },
  { value: 'allUsers', label: 'All Users' },
  { value: 'inactiveUsers', label: 'Inactive Users' },
  { value: 'region', label: 'Users in Region (polygon-based)' },
];

const PushNotification = (props) => {
  const [region, setRegion] = useState({ concelho: '', freguesia: '' });

  return (
    <Card>
      <CardHeader title="Send Push Notification" />
      <Divider />
      <CardContent>
        <Formik
          initialValues={{
            send_to: selectNotificationTo[0].value,
            title: '',
            message: '',
          }}
          validationSchema={Yup.object().shape({
            send_to: Yup.string().max(255).required('Select Notification To is required'),
            message: Yup.string().max(255).required('Message is required'),
          })}
          onSubmit={async (values) => {
            const payload = { ...values };
            if (values.send_to === 'region') {
              if (!region.concelho) {
                // eslint-disable-next-line no-alert
                window.alert('Pick a municipality (and optional parish) first.');
                return;
              }
              payload.region = region;
            }
            props.handlePushNotification(payload);
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Select Notification To"
                name="send_to"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.send_to}
                variant="outlined"
              >
                {selectNotificationTo.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
              {values.send_to === 'region' && (
                <Box pt={2}>
                  <RegionSelector value={region} onChange={setRegion} label="Target region" />
                  <FormHelperText>
                    Targets users via on-device geofencing (no user location leaves the device).
                  </FormHelperText>
                </Box>
              )}
              <TextField
                fullWidth
                label="Title (optional)"
                margin="normal"
                name="title"
                onChange={handleChange}
                value={values.title}
                variant="outlined"
              />
              <TextField
                error={Boolean(touched.message && errors.message)}
                fullWidth
                helperText={touched.message && errors.message}
                label="Enter a message"
                margin="normal"
                name="message"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.message}
                variant="outlined"
              />
              <Box paddingY={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      size="large"
                      fullWidth
                      type="submit"
                      variant="contained"
                    >
                      SEND PUSH NOTIFICATION
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
};

PushNotification.propTypes = {
  handlePushNotification: PropTypes.func,
};

export default PushNotification;
